"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HOME_OPEN_GRID = exports.HOME_OPEN_MAP = void 0;
const BaseStore = require("fluxible/addons/BaseStore");
class HomeStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.dispatcher = dispatcher;
        this.mapLocks = [];
    }
    handleMapLocks(mapLocks) {
        this.mapLocks = mapLocks;
        this.emitChange();
    }
    getMapLocs() {
        return this.mapLocks;
    }
    dehydrate() {
        return {
            mapLocks: this.mapLocks
        };
    }
    rehydrate(state) {
        this.mapLocks = state.mapLocks;
    }
}
exports.HOME_OPEN_MAP = 'HOME_OPEN_MAP';
exports.HOME_OPEN_GRID = 'HOME_OPEN_GRID';
HomeStore.storeName = 'HomeStore';
HomeStore.handlers = {
    HOME_OPEN_MAP: 'handleMapLocks',
    HOME_OPEN_GRID: 'handleEntity',
};
exports.default = HomeStore;
